import React from 'react';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Services from "./components/Services";
import WhatWeDo from "./components/WhatWeDo";
import Experts from "./components/Experts";
import Projects from "./components/Projects";
import ContactForm from "./components/ContactForm";
import Footer from "./components/Footer";
import About from "./components/About";
import Team from "./components/Team";
import Contacts from "./components/Contacts";
import ProjectsPage from "./components/ProjectsPage";
import ProjectDetail from "./components/ProjectDetail";
import CompletedProjects from "./components/CompletedProjects";
import OngoingProjects from "./components/OngoingProjects";
import WeldingServices from "./components/services/WeldingServices";
import FabricationServices from "./components/services/FabricationServices";
import InstallationServices from "./components/services/InstallationServices";
import MaintenanceServices from "./components/services/MaintenanceServices";
import NewTrainings from "./components/training/NewTrainings";
import EngineeringEcosystem from "./components/EngineeringEcosystem";
import AnimatedBackground from "./components/AnimatedBackground";
import AnimatedDivider from "./components/AnimatedDivider";
import ResearchDevelopment from "./components/services/ResearchDevelopment";
import FarmMachinery from "./components/services/FarmMachinery";
import EnergyEngineering from "./components/services/EnergyEngineering";
import MarineEngineering from "./components/services/MarineEngineering";
import WoodEngineering from "./components/services/WoodEngineering";
import PlumbingEngineering from "./components/services/PlumbingEngineering";
import SustainableBuilding from "./components/services/SustainableBuilding";
import TVETTraining from "./components/services/TVETTraining";
import SoftwareML from "./components/services/SoftwareML";
import GlobalSearch from "./components/GlobalSearch";

const App: React.FC = () => {
  return (
    <Router>
      <div className="min-h-screen relative">
        <AnimatedBackground />
        <Navbar />
        <GlobalSearch />
        <Routes>
          <Route
            path="/"
            element={
              <>
                <Hero />
                <AnimatedDivider variant="gears" />
                <Services />
                <AnimatedDivider variant="tools" />
                <EngineeringEcosystem />
                <AnimatedDivider variant="mixed" />
                <WhatWeDo />
                <Experts />
                <Projects />
                <ContactForm />
              </>
            }
          />
          <Route path="/about" element={<About />} />
          <Route path="/team" element={<Team />} />
          <Route path="/contacts" element={<Contacts />} />
          <Route path="/projects" element={<ProjectsPage />} />
          <Route path="/projects/:id" element={<ProjectDetail />} />
          <Route path="/projects/completed" element={<CompletedProjects />} />
          <Route path="/projects/ongoing" element={<OngoingProjects />} />
          <Route path="/services/research-development" element={<ResearchDevelopment />} />
          <Route path="/services/farm-machinery" element={<FarmMachinery />} />
          <Route path="/services/energy-engineering" element={<EnergyEngineering />} />
          <Route path="/services/marine-engineering" element={<MarineEngineering />} />
          <Route path="/services/wood-engineering" element={<WoodEngineering />} />
          <Route path="/services/plumbing-engineering" element={<PlumbingEngineering />} />
          <Route path="/services/sustainable-building" element={<SustainableBuilding />} />
          <Route path="/services/tvet-training" element={<TVETTraining />} />
          <Route path="/services/software-ml" element={<SoftwareML />} />
          <Route path="/services/welding" element={<WeldingServices />} />
          <Route
            path="/services/fabrication"
            element={<FabricationServices />}
          />
          <Route
            path="/services/installation"
            element={<InstallationServices />}
          />
          <Route
            path="/services/maintenance"
            element={<MaintenanceServices />}
          />
          <Route path="/training/new-trainings" element={<NewTrainings />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
};

export default App;
